/* global axios */

import ApiClient from './ApiClient';

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  get({
    page,
    actionType,
    excludeAction,
    auditableType,
    userId,
    from,
    to,
    category,
  } = {}) {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (page) params.append('page', page);
    if (actionType) params.append('action_type', actionType);
    if (excludeAction) params.append('exclude_action', excludeAction);
    if (auditableType) params.append('auditable_type', auditableType);
    if (userId) {
      const ids = Array.isArray(userId) ? userId : [userId];
      ids.forEach(id => params.append('user_id[]', id));
    }
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const query = params.toString();
    const url = query ? `${this.url}?${query}` : this.url;
    return axios.get(url);
  }

  // rev9/P3 — descarga CSV (Excel) respetando los filtros actuales.
  download({
    actionType,
    excludeAction,
    auditableType,
    userId,
    from,
    to,
    category,
  } = {}) {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (actionType) params.append('action_type', actionType);
    if (excludeAction) params.append('exclude_action', excludeAction);
    if (auditableType) params.append('auditable_type', auditableType);
    if (userId) {
      const ids = Array.isArray(userId) ? userId : [userId];
      ids.forEach(id => params.append('user_id[]', id));
    }
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const query = params.toString();
    const url = query
      ? `${this.url}/download?${query}`
      : `${this.url}/download`;
    return axios.get(url, { responseType: 'blob' });
  }
}

export default new AuditLogs();
